export const shouldRenderSliderMediaForIndex = (
  slideIndex: number,
  activeIndex: number,
  totalSlides: number
) => {
  if (totalSlides <= 0) {
    return false
  }

  const nextIndex = (activeIndex + 1) % totalSlides
  return slideIndex === activeIndex || slideIndex === nextIndex
}

